import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

import LanguageDetector from 'i18next-browser-languagedetector';

// Initialize i18next with generic language setup
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'it',
    supportedLngs: ['en', 'it', 'fr', 'de', 'es'],
    ns: ['common', 'dashboard', 'events', 'teams', 'users', 'forms'],
    defaultNS: 'common',
    debug: false,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false }
  });

// Keep <html lang> in sync for a11y
i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
});

export default i18n;
